import messages from './cmsLifecycleToast.json' with { type: 'json' };

export const cmsLifecycleToastFi: Readonly<typeof messages> = messages;
